module.exports = __webpack_public_path__ + "media/images/admin/undraw_conference_speaker_re_1rna-a923290cb6ed2eb8bc5fd656e1b2a132.svg";